module.exports = __webpack_public_path__ + "images/emoji/school_satchel.4d4e14daaa9ab3032b6a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/school_satchel.png
// module id = ppNP
// module chunks = 1